import React from 'react';

import classes from './HorizontalCardField.module.scss';

const HorizontalCardField = ({ className, classChildren, title, children }) => {
  return (
    <div className={`${className} ${classes.text}`}>
      <span className={`${classes.title} medium-12`}>{title}</span>
      <div className={`semibold-16 ${classChildren}`}>{children}</div>
    </div>
  );
};

export default HorizontalCardField;
